<script>
import MineTitle from '../../components/mineTitle.vue';

export default {
    name: "files",
    data() {
        return {
            typeList: ['ID Card', 'CV', 'Education Qualification', 'Driving Licence', 'Passport'],
            type: 'ID Card',
            fileName: '',
            isLoading: false,
            files: [],
        };
    },
    computed: {},
    components: {
        MineTitle
    },
    mounted() {
        this.$store.dispatch('getUserFile').then((result) => {
            if (result.code == 100) { 
                this.files = result.data;
            }
            else if (result.code == 90) { 
                this.$router.replace({
                    path: '/login',
                    query: { redirect: this.$route.fullPath }
                })
            }
        }).catch((err) => {
            
        });
    },
    destroyed() {},
    watch: {},
    methods: {
        save() { 
            if(this.isLoading){
                return false;
            }
            this.isLoading = true;
            const file = this.$refs.file.files[0];
            const type = file.type;
            this.getFileReader(file, type);
        },
        getFileData() { 
            const file = this.$refs.file.files[0];
            // console.log(file)
            this.fileName = file.name;
        },
        getFileReader(file, type){
            // let self = this;
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                // console.log(reader);
                let _img = new Image();
                _img.src = reader.result;
                _img.onload = () => {
                    // 压缩
                    if(file.size > 512*1024){
                        this.suofang(reader.result, 1.5, type, (blob, base64)=>{
                            this.upLoad(blob);
                        })
                    }else{
                        this.upLoad(file);
                    }
                }
            };
        },
        upLoad(data){
            // 上传
            let formData = new FormData();
            formData.append('file', data);
            formData.append('token', localStorage.getItem('token'));
            formData.append('type', this.type);
            this.$store.dispatch('upFile', formData).then((result) => {
                this.isLoading = false;
                if (result.code == 100) {
                    this.$showToast({ text: 'Upload successfully' }); //上传成功
                }
                else if (result.code == 90) { 
                    this.$router.replace({
                        path: '/login',
                        query: { redirect: this.$route.fullPath }
                    })
                }
            }).catch((err) => {
                this.isLoading = false;
                this.$showToast({ text: 'Upload failed' }); //上传失败
            });;
        },
        suofang(base64, bili, type, callback) {
            // console.log("执行缩放程序,bili=" + bili);
            //处理缩放，转格式
            let self = this;
            var _img = new Image();
            _img.src = base64;
            _img.onload = function() {
                var _canvas = document.createElement("canvas");
                var w = this.width / bili;
                var h = this.height / bili;
                _canvas.setAttribute("width", w);
                _canvas.setAttribute("height", h);
                _canvas.getContext("2d").drawImage(this, 0, 0, w, h);
                var base64 = _canvas.toDataURL(type);
                _canvas.toBlob(function(blob) {
                    // console.log(blob.size);
                    if(blob.size > 512*1024){
                        self.suofang(base64, bili, type, callback);
                    }else{
                        callback(blob, base64);
                    }
                }, type);
            }
        },
    },
};
</script>

<template>
    <div class="files">
        <MineTitle name="Documents" page="Mine / Documents"/>
        <div class="wrapper">
            <div class="input_group">
                <div class="name">Upload</div>
                <input type="file" ref="file" name="file" id="" style="display: none;" accept="image/*" capture="camera" @change="getFileData"/>
                <div class="input flex align_center" @click="$refs.file.click()">
                    <div class="btn_file flex_center">选择文件</div>
                    <p class="text" v-if="fileName">{{ fileName }}</p>
                    <p class="text" v-else>未选择任何文件</p>
                </div>
            </div>
            <div class="input_group">
                <div class="name">Type of Document</div>
                <select name="" id="" v-model="type">
                    <option :value="item" v-for="(item, index) in typeList" :key="index">{{ item }}</option>
                </select>
            </div>
            <div class="btn flex_center" @click="save">save</div>
        </div>
        <div class="layout_table table">
            <div class="thead">
                <div class="tr">
                    <div class="td">Sl. No.</div>
                    <div class="td">Document Type</div>
                    <div class="td">File options</div>
                </div>
            </div>
            <div class="tbody">
                <div class="tr" v-for="(item, index) in files" :key="index">
                    <div class="td">{{ item.id }}</div>
                    <div class="td">{{ item.type }}</div>
                    <div class="td"><img :src="item.file" alt=""/></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.table{
    font-size: .16rem;
}
.wrapper{
    background: #e1e4ea;
    border-radius: .05rem;
    padding: .4rem;
    margin-bottom: .4rem;
    @media only screen and (max-width: 750px) {
        padding: .4rem .2rem;
    }
}
.input_group{
    width: 5.6rem;
    margin-bottom: .25rem;
    @media only screen and (max-width: 750px) {
        width: auto;
        margin-bottom: .4rem;
    }
    .name{
        font-size: .16rem;
        color: #666;
        margin-bottom: .15rem;
        @media only screen and (max-width: 750px) {
            font-size: .24rem;
        }
    }
    select,
    .input{
        width: 100%;
        height: .5rem;
        border: 1px solid #c9c9c9;
        background: #fff;
        border-radius: .05rem;
        padding: 0 .25rem;
        font-size: .16rem;
        cursor: pointer;
        outline: none;
        color: #666;
        box-sizing: border-box;
        .btn_file{
            width: .8rem;
            height: .26rem;
            background: #efefef;
            border: 1px solid #666;
            border-radius: .03rem;
            margin-right: .3rem;
            flex-shrink: 0;
            color: #333;
        }
        .text{
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
.btn{
    font-size: .24rem;
    background: var(--background-color);
    color: var(--color-blue);
    width: 1.2rem;
    height: .4rem;
    border-radius: .4rem;
    cursor: pointer;
    font-weight: bold;
}
</style>